module.exports = __webpack_public_path__ + "img/tag-undetermined.c8e6d09c.svg";